import swal from "sweetalert";

export const deleteNow = (deleteIt) => {
    swal({
        title: "Are you sure?",
        text: "You really want to delete.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    })
        .then((willDelete) => {
            if (willDelete) {
                deleteIt && deleteIt()
                swal("Deleted Successfully!", {
                    icon: "success",
                });
            }
        });
        
}